import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Button, Input, Popconfirm, message, Form, Upload, Icon } from 'antd'
import styled from 'styled-components'
import { actions } from '../../redux/modules/templatesActions'
import { actions as itemActions } from '../../redux/modules/jobFunctions/itemActions'
import history from '../../history'

const Container = styled.div`
  padding: 25px;
`
const MarginTop = styled.div`
  margin-top: 15px;
`
const propTypes = {}
const FormItem = Form.Item
const { TextArea } = Input

class TemplatesForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentKey: 'form',
      currentId: +this.props.match.params.templateId,
      fileList: []
    }
  }

  componentWillMount() {
    this.props.getTemplateById({
      templateType: this.state.currentKey,
      templateId: this.state.currentId
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.templatesActions && this.props.templatesActions.loadedTemplate) {
      if (
        this.props.templatesActions.loadedTemplate !== prevProps.templatesActions.loadedTemplate
      ) {
        const loadedTemplate = this.props.templatesActions.loadedTemplate.data[0]
        if (loadedTemplate) {
          this.setState({
            templateName: loadedTemplate.name,
            templateDescription: loadedTemplate.description,
            templateFilename: loadedTemplate.attachment_filename,
            templateFileUrl: loadedTemplate.attachment_url
          })
        }
      }
    }
  }

  handleInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleCreate = () => {
    const form = this.props.form
    const { currentId } = this.state
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const { fileList } = this.state
      const formData = new FormData()
      fileList.forEach(file => {
        formData.append('file', file)
      })
      formData.append('description', values.description)
      formData.append('name', values.name)
      formData.append('estimate_template_id', currentId)
      formData.append('userId', this.props.authentication.user.userId)
      formData.append('templateType', 'form')

      if (currentId === 0) {
        this.props.createTemplateWithAttachment({
          formData: formData
        })
      } else {
        this.props.saveTemplateWithAttachment({
          templateId: this.state.currentId,
          formData: formData
        })
      }

      message.success('Changes saved.')
      this.setState({ contentData: null, currentId: 0, modalVisible: false })
    })
  }

  confirmDelete = () => {
    this.props.deleteTemplate({
      templateId: this.state.currentId,
      templateType: 'form'
    })

    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { fileList } = this.state
    const fileUploadProps = {
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file)
          const newFileList = state.fileList.slice()
          newFileList.splice(index, 1)
          return {
            fileList: newFileList
          }
        })
      },
      beforeUpload: file => {
        this.setState(state => ({
          fileList: [...state.fileList, file]
        }))
        return false
      },
      fileList
    }

    const { templateName, templateDescription, templateFilename, templateFileUrl } = this.state
    console.log(templateFilename, templateFileUrl)
    return (
      <Container>
        <Form>
          <h2>Form Template</h2>
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Template Name">
                {getFieldDecorator('name', {
                  rules: [
                    {
                      required: true,
                      message: 'Template name cannot be blank.'
                    }
                  ],
                  initialValue: templateName ? templateName : ''
                })(<Input />)}
              </FormItem>
            </div>
          </div>
          <FormItem label="Description">
            {getFieldDecorator('description', {
              initialValue: templateDescription ? templateDescription : ''
            })(
              <TextArea
                placeholder="Type in description..."
                rows={4}
                onChange={event =>
                  this.handleInputChange(event.target.value, 'templateDescription')
                }
              />
            )}
          </FormItem>
          <FormItem label="Files">
            {getFieldDecorator('file', {
              // rules: [
              //   {
              //     required: !content ? false : true,
              //     message: 'FFFF cannot be blank.'
              //   }
              // ],
              // initialValue: content ? content.description : ''
            })(
              <Upload {...fileUploadProps}>
                <Button>
                  <Icon type="upload" /> Upload
                </Button>
              </Upload>
            )}
          </FormItem>
          {templateFileUrl && (
            <div className="row">
              <div className="col-md-12">
                Uploaded file: <a href={templateFileUrl}>{templateFilename}</a>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-12">
              <MarginTop>
                {this.state.currentId > 0 && (
                  <Popconfirm
                    title="Are you sure you want to delete this record?"
                    onConfirm={this.confirmDelete}
                    onCancel={this.cancelDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="danger" icon="delete" className="mr-2" />
                  </Popconfirm>
                )}
              </MarginTop>
            </div>
          </div>
          <MarginTop>
            <Button onClick={() => history.goBack()}>Cancel</Button>{' '}
            <Button type="primary" onClick={() => this.handleCreate()}>
              {this.state.currentId === 0 && <span>Create Template</span>}
              {this.state.currentId > 0 && <span>Save Changes</span>}
            </Button>
          </MarginTop>
        </Form>
      </Container>
    )
  }
}

const mapStateToProps = ({ templatesActions, itemActions, authentication }, ownProps) => ({
  templatesActions,
  itemActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, itemActions), dispatch)
})

TemplatesForm.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(TemplatesForm))
)



// WEBPACK FOOTER //
// ./src/containers/templates/formTemplate.js